// extracted by mini-css-extract-plugin
module.exports = {"dogovor":"DocumentiPravila_dogovor__9teIi","inDogovor":"DocumentiPravila_inDogovor__oZXF5","h2":"DocumentiPravila_h2__1vXLu","h1":"DocumentiPravila_h1__3s_yU"};